import { css } from 'styled-components';
import { TYPOGRAPHY, COLORS } from '../../design/tokens';

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    padding-top: 8px;
    padding-bottom: 8px;
    width: 100%;
  `,
  input: css`
    color: ${COLORS.INPUT.TEXT}
    text-align: ${props => props.align};
    font-family: ${TYPOGRAPHY.BASE.FONT_FAMILY} !important;
    font-size: 16px !important;
    margin-top: 4px;
    &.input > input {
      border-radius: 0 !important;
      border-width: 2px !important;
      padding-bottom: 6px !important;
      padding-top: 4px !important;
      height: 40px !important;
    }


    &:hover input {
      border-color: ${COLORS.INPUT.HOVER.BORDER} !important;
    }
  `,
  message: css`
    color: ${props =>
      props.error ? COLORS.INPUT.ERROR.TEXT : COLORS.INPUT.TEXT};
    margin-top: 6px;
  `,
  textArea: css`
    border-radius: 4px;
    border: 1px solid ${COLORS.TEXT_AREA.BORDER};
    color: ${COLORS.TEXT.BLACK};
    text-align: ${props => props.align};
    font-family: ${TYPOGRAPHY.BASE.FONT_FAMILY};
    height: ${props => props.height};
    padding: 14px 16px;

    &:hover {
      border-color: ${COLORS.TEXT_AREA.HOVER.BORDER} !important;
    }
  `,
  dropdownContainer: css`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 5px;
  `,
  inputContainer: css`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: nowrap;

    .country-selector {
       > div {
         border-top-right-radius: 0;
         border-bottom-right-radius: 0;
         border-right-color: transparent;
       }
     }
     &.with-country-selector {
      > div {
        padding: 0;
      }
       input {
         border-top-left-radius: 0;
         border-bottom-left-radius: 0;
       }
    }

    > .input {
      flex: 1;
    }
  `
};

export default styles;
